import { Card, Grid, Stack, Tooltip } from '@mui/material';
import React, { FunctionComponent } from 'react';
import { WsColors, WsTypoColors, WsTypography, WsTypoVariants } from 'wisestep-base';

interface InvoiceDetailCardProps {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
  right?: React.ReactNode;
}

export const properties = { color: WsTypoColors.SECONDARY, variant: WsTypoVariants.BODY1 };

export const InvoiceDetailsCardAttribute: FunctionComponent<{
  columns: number;
  tooltipTitle?: string;
}> = ({ children, columns, tooltipTitle }) => {
  return (
    <Grid item xs={columns}>
      <Tooltip title={tooltipTitle ?? ''} placement="top-start">
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{ color: WsColors.GreyBlack, fontSize: 'inherit' }}
        >
          {children}
        </Stack>
      </Tooltip>
    </Grid>
  );
};

const InvoiceDetailsCard = ({ children, icon, right, title }: InvoiceDetailCardProps) => {
  return (
    <Card sx={{ p: 2 }} elevation={0}>
      <Stack direction="row" justifyContent="space-between">
        <Stack direction="row" spacing={1.5} alignItems="center">
          {icon}
          <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.BLACK} bold={true}>
            {title}
          </WsTypography>
        </Stack>
        {right}
      </Stack>
      <Grid container spacing={1} mt={1}>
        {children}
      </Grid>
    </Card>
  );
};

export default InvoiceDetailsCard;
